import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BehaviorSubject } from 'rxjs';

const REFRESH_INBERVAL_MS = 600_000;

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  private idToken: any = null;
  private _isAuthenticated: boolean = false;
  private _user: any = null;
  public user$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isAuthenticated$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public idTokenClaims$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private readonly auth: AuthService) {
    console.log('SecurityService!!!!');

    this.auth.isAuthenticated$.subscribe((res) => {
      this._isAuthenticated = res;
      this.isAuthenticated$.next(res);
    });

    this.auth.user$.subscribe((res) => {
      this._user = res;
      this.user$.next(res);
    });

    this.auth.idTokenClaims$.subscribe({
      next: (claims: any) => {
        if (claims) {
          this.idToken = claims.__raw;
          this.idTokenClaims$.next(claims);
        }
      },
      error: (error) => {
        console.error('Error fetching ID token:', error);
      },
    });

    setInterval(() => this.refreshAccessToken(), REFRESH_INBERVAL_MS);
  }

  public isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  public getUser() {
    return this._user;
  }

  public getIdToken(): string {
    return this.idToken;
  }

  public login() {
    this.auth.loginWithRedirect();
  }

  public logout() {
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin, // This will redirect to the homepage after logout
      },
    });
  }

  public async refreshAccessToken() {
    this.auth.idTokenClaims$.subscribe({
      next: (claims: any) => {
        if (claims) {
          this.idToken = claims.__raw;
          this.idTokenClaims$.next(claims);
        }
      },
      error: (error) => {
        console.error('Error fetching ID token:', error);
      },
    });
  }
}
